import { AsyncPipe } from '@angular/common';
import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UserAccount } from '@app/modules/@core/core.types';
import { LoadUserByIdAction } from '@app/modules/@core/store/user-accounts/user-accounts.actions';
import { UserAccountsState } from '@app/modules/@core/store/user-accounts/user-accounts.state';
import { Store } from '@ngxs/store';
import { Observable, ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-user-display',
  styles: [``],
  template: ` {{ getUserDisplayString(user$ | async) }} `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe],
})
export class UserDisplayComponent {
  private store = inject(Store);

  user$: Observable<UserAccount>;
  private readonly userIdSubject = new ReplaySubject<string>(1);
  constructor() {
    this.user$ = this.userIdSubject.pipe(
      switchMap((userId) =>
        this.store
          .dispatch(new LoadUserByIdAction(userId))
          .pipe(
            switchMap(() =>
              this.store
                .select(UserAccountsState.getUserById)
                .pipe(map((filterById) => filterById(userId)))
            )
          )
      )
    );
  }

  @Input()
  set userId(id: string) {
    this.userIdSubject.next(id);
  }

  getUserDisplayString(user: UserAccount): string {
    if (user && user.email) {
      return user.email.split('@')[0];
    }
    return '';
  }
}
